var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36601 10.5C6.98111 11.1667 6.01886 11.1667 5.63396 10.5L0.87082 2.25C0.48592 1.58333 0.967046 0.749999 1.73685 0.749999L11.2631 0.75C12.0329 0.75 12.5141 1.58333 12.1292 2.25L7.36601 10.5Z",
    fill: "#4FBC9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownReverse);
export default __webpack_public_path__ + "static/media/caret-down-reverse.4a71072506b957de440289e15466701d.svg";
export { ForwardRef as ReactComponent };